import React, { useState, useEffect, Fragment } from 'react';
import { PROJECTNAME, PROJECTNAMEALIAS,PROJECTCLIENTSIDEURL } from "../helpers/Setup"
import { handleLogout, getAllSessionData, getCartCount, manipulateCartAfterLoggedIn, handleCartManipulation, showToast, showConfirmPurchase, callAPI,showHttpError,setSessionData,getCartDataAfterLoggedIn } from '../helpers/Library';
import Cookies from "js-cookie";


const Footer = (props) => {
    const [copyRightYear, setCopyRightYear] = useState(0);

    const [privacypolicy, setPrivacypolicy] = useState(window.location.origin+'/terms-of-use');
    const [termsCondition, setTermsCondition] = useState(window.location.origin+'/privacy-policy');


    let geBrokerDetails = () =>{
        // setShowLoader(true)
        // let payload = { "address": obj.account, "networkId": obj.chainId, "isExternal": 1 }
        if((localStorage.getItem('nftBrokerId') === undefined || localStorage.getItem('nftBrokerId') === 'undefined') && Cookies.get(PROJECTNAMEALIAS + "broker_id") === undefined){
            return;
        }
        const brokerId = localStorage.getItem('nftBrokerId') != undefined && localStorage.getItem('nftBrokerId') != 'undefined' ? localStorage.getItem('nftBrokerId') : Cookies.get(PROJECTNAMEALIAS + "broker_id") !== undefined ? Cookies.get(PROJECTNAMEALIAS + "broker_id") : 'PAYB18022021121103';
        callAPI('get', `https://accounts.paybito.com/api/home/getBrokerWiseExchangeInfo?brokerId=${brokerId}`, false).then((res) => {
            let response = res.data.value[0];

            // console.log('brokerrsss',response);
            localStorage.setItem('nftBrokerloginRedirectionDomain',res.data.domain + '?login-for=nft')
            if(response != undefined && response != null && response.facebook_link != null && response.facebook_link != undefined){
                if(response.facebook_link.indexOf("https://") != -1){
                    var facebook_link = response.facebook_link
                  }
                  else{
                    var facebook_link = 'https://'+response.facebook_link
                  }

            }else{
                var facebook_link = '#'
            }
            if(response != undefined && response != null && response.twitter_link != null && response.twitter_link != undefined){
              if(response.twitter_link.indexOf("https://") != -1){
                var twitterLink = response.twitter_link
              }
              else{
                var twitterLink = 'https://'+response.twitter_link
              }
            }else{
                var twitterLink = '#'
            }
            if(response != undefined && response != null && response.linkedin_link != null && response.linkedin_link != undefined){
              if(response.linkedin_link.indexOf("https://") != -1){
                var linkedin_link = response.linkedin_link
              }
              else{
                var linkedin_link = 'https://'+response.linkedin_link
              }
            }else{
                var linkedin_link = '#'
            }

            localStorage.setItem('facebookLink',facebook_link)
            localStorage.setItem('twitterLink',twitterLink)
            localStorage.setItem('linkedinLink',linkedin_link)
           


            


        



           

        }, (error) => {
            // showHttpError(error)
        })
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        /* Setting copyright year */
        let date = new Date();
        setCopyRightYear(date.getFullYear());
        geBrokerDetails()
    });

    return (
        <Fragment>
            {/* Start Footer  */}
            <footer>
                <div className="footer-main">
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-lg-4 col-md-12 col-sm-12">
						<div className="footer-top-box">
							<h3>Business Time</h3>
							<ul className="list-time">
								<li>Monday - Friday: 08.00am to 05.00pm</li> <li>Saturday: 10.00am to 08.00pm</li> <li>Sunday: <span>Closed</span></li>
							</ul>
						</div>
					</div> */}
                            {/* <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="footer-top-box">
                                    <h3>Newsletter</h3>
                                    <form className="newsletter-box">
                                        <div className="form-group">
                                            <input className="" type="email" name="Email" placeholder="Email Address*" />
                                            <i className="fa fa-envelope"></i>
                                        </div>
                                        <button className="btn hvr-hover" type="submit">Submit</button>
                                    </form>
                                </div>
                            </div> */}
                            <div className="col-lg-8 col-md-12 col-sm-12">
                                <div className="footer-widget">
                                    <h4>About {PROJECTNAME}</h4>
                                    <p>The world’s first and largest digital marketplace for crypto collectibles and non-fungible tokens (NFTs). Buy, sell, and discover exclusive digital items.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12 ">
                                <div className="footer-widget footer-top-box">
                                    <h4>Social Media</h4>
                                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                                    <ul>
                                        <li><a href={localStorage.getItem('facebookLink')} target='_blank'><i className="fab fa-facebook" aria-hidden="true"></i></a></li>
                                        <li><a href={localStorage.getItem('twitterLink')} target='_blank'><i className="fab fa-twitter" aria-hidden="true"></i></a></li>
                                        <li><a href={localStorage.getItem('linkedinLink')} target='_blank'><i className="fab fa-linkedin" aria-hidden="true"></i></a></li>
                                        {/* <li><a href="https://www.youtube.com/c/HashCashConsultantsOfficialChannel" target='_blank'><i className="fab fa-youtube" aria-hidden="true"></i></a></li>
                                        <li><a href="https://www.instagram.com/paybitopro/" target='_blank'><i className="fab fa-instagram" aria-hidden="true"></i></a></li>
                                        <li><a href="https://t.me/paybitopro" target='_blank'><i className="fab fa-telegram" aria-hidden="true"></i></a></li> */}

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">

                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="footer-link">
                                    <h4>Information</h4>
                                    <ul>
                                        {/* <li><a href="https://www.paybito.com/team/" target="_blank">About Us</a></li>
                                        <li><a href="https://www.paybito.com/contact-us/" target="_blank">Customer Service</a></li> */}
                                        <li><a href={termsCondition} target="_blank">Terms &amp; Conditions</a></li>
                                        <li><a href={privacypolicy} target="_blank">Privacy Policy</a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className="footer-link-contact">
                            <h4>Contact Us</h4>
                            <ul>
                                <li>
                                    <p><i className="fas fa-map-marker-alt"></i>Address: Michael I. Days 3756 <br></br>Preston Street Wichita,<br></br> KS 67213 </p>
                                </li>
                                <li>
                                    <p><i className="fas fa-phone-square"></i>Phone: <a href="tel:+1-888705770">+1-888 705 770</a></p>
                                </li>
                                <li>
                                    <p><i className="fas fa-envelope"></i>Email: <a href="mailto:contactinfo@gmail.com">contactinfo@gmail.com</a></p>
                                </li>
                            </ul>
                        </div>
                    </div> */}
                        </div>
                    </div>
                </div>
            </footer>
            {/* End Footer  */}

            {/* Start copyright  */}
            <div className="footer-copyright">
                <p className="footer-company">© 2024 <a href="https://www.paybito.com/" target='_blank'>{localStorage.getItem('nftBrokerExchangeName')}</a>. All Rights Reserved.</p>
            </div>
        </Fragment>
    );
}

export default Footer;